(() => {
  let requestId = 0;
  let controller;
  function setupNav() {
    const nav = document.querySelector('[data-bc-delivery-nav]');
    if (!nav) return;
    const current = new URL(location.href);
    const pickup = current.searchParams.get('bc_pickup') === '1';
    const mode = pickup ? 'pickup' : current.pathname.includes('/envio-gratis') ? 'free' : current.pathname.includes('/envio-express') ? 'express' : 'all';
    nav.querySelectorAll('[data-mode]').forEach(link => {
      const next = new URL(link.getAttribute('href'), location.origin);
      const params = new URLSearchParams(current.search);
      params.delete('page'); params.delete('bc_pickup'); params.delete('section_id');
      if (link.dataset.mode === 'pickup') params.set('bc_pickup', '1');
      next.search = params.toString();
      link.href = next.pathname + next.search;
      if (link.dataset.mode === mode) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
      if (!link.dataset.bound) {
        link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
        link.dataset.bound = 'true';
      }
    });
    document.body.classList.toggle('bc-pickup-active', pickup);
    if (pickup) loadPickup(nav);
    else { controller?.abort(); document.querySelector('.bc-pickup-results')?.remove(); }
  }
  async function loadPickup(nav) {
    const gridContainer = document.querySelector('#ProductGridContainer .collection');
    if (!gridContainer) return;
    const run = ++requestId;
    controller?.abort(); controller = new AbortController();
    document.querySelector('.bc-pickup-results')?.remove();
    const output = document.createElement('div');
    output.className = 'bc-pickup-results'; output.setAttribute('aria-busy', 'true');
    const status = document.createElement('p'); status.setAttribute('role', 'status'); status.textContent = nav.dataset.loading;
    output.append(status); gridContainer.append(output);
    try {
      let url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('section_id', 'bc-pickup-catalog');
      const cards = []; const seen = new Set(); const seenPages = new Set();
      while (url) {
        if (seenPages.has(url.href)) throw new Error('Repeated page');
        seenPages.add(url.href);
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('Availability unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = html.querySelector('[data-bc-pickup-page]');
        if (!page) throw new Error('Availability unavailable');
        page.querySelectorAll('[data-bc-pickup-product]').forEach(card => {
          if (!seen.has(card.dataset.bcPickupProduct)) { seen.add(card.dataset.bcPickupProduct); cards.push(card); }
        });
        url = page.dataset.next ? new URL(page.dataset.next, location.origin) : null;
        if (url) url.searchParams.set('section_id','bc-pickup-catalog');
      }
      if (run !== requestId || !output.isConnected) return;
      status.textContent = cards.length ? nav.dataset.note : nav.dataset.empty;
      const countText = nav.dataset.count.replace('__COUNT__', cards.length);
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(el => {el.textContent = countText;});
      if (cards.length) {
        const list = document.createElement('ul'); list.className = 'grid product-grid contains-card--product'; list.setAttribute('role','list');
        list.append(...cards); output.append(list);
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = nav.dataset.error;
      const retry = document.createElement('button'); retry.className = 'button button--secondary'; retry.type = 'button'; retry.textContent = nav.dataset.retry;
      retry.addEventListener('click', () => loadPickup(nav)); output.append(retry);
    } finally {output.setAttribute('aria-busy','false');}
  }
  function setupSlides() {
    document.querySelectorAll('slideshow-component').forEach(slider => {
      if (slider.dataset.bcMotion) return;
      slider.dataset.bcMotion = 'true';
      const stop = () => {
        if (slider.autoplayButtonIsSetToPlay) {slider.autoplayButtonIsSetToPlay = false;slider.pause?.();slider.togglePlayButtonState?.();}
      };
      slider.addEventListener('pointerdown', event => {if (!event.target.closest('.slideshow__autoplay')) stop();});
      slider.addEventListener('focusin', event => {if (!event.target.closest('.slideshow__autoplay')) stop();});
      slider.addEventListener('mouseenter', () => slider.pause?.());
      slider.addEventListener('mouseleave', () => {if (slider.isAutoplay && slider.autoplayButtonIsSetToPlay) slider.play?.();});
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      if (media.matches) stop();
      media.addEventListener('change', () => {if (media.matches) stop();});
    });
  }
  setupNav();
  customElements.whenDefined('slideshow-component').then(() => {requestAnimationFrame(setupSlides);});
  document.addEventListener('bc:collection-rendered',setupNav);
  document.addEventListener('shopify:section:load', () => {setupNav();setupSlides();});
  window.addEventListener('popstate', () => {setTimeout(setupNav, 0);});
})();

